import { sendBusPageLoad } from "src/analytics/useAnalytics";
import {
  ChartData,
  DropOffData,
  PickDropProps,
  PickUpData,
  seatStatus,
} from "./types";
// import { sendToGTM } from "src/analytics/gtmGA";
import dayjs from "dayjs";

export const roundedRect = (
  x: any,
  y: any,
  width: any,
  height: any,
  radius: number
) => {
  return new Path2D(
    `M ${x + radius} ${y} H ${
      x + width - radius
    } a ${radius} ${radius} 0 0 1 ${radius} ${radius} V ${
      y + height - radius
    } a ${radius} ${radius} 0 0 1 ${-radius} ${radius} H ${
      x + radius
    } a ${radius} ${radius} 0 0 1 ${-radius} ${-radius} V ${
      y + radius
    } a ${radius} ${radius} 0 0 1 ${radius} ${-radius}`
  );
};

export const roundRect = (
  context: {
    beginPath: () => void;
    moveTo: (arg0: any, arg1: any) => void;
    lineTo: (arg0: number, arg1: number) => void;
    quadraticCurveTo: (
      arg0: any,
      arg1: any,
      arg2: number,
      arg3: number
    ) => void;
    stroke: () => void;
  },
  x: any,
  y: any,
  w: any,
  h: any,
  radius: number
) => {
  const r = x + w;
  const b = y + h;
  context.beginPath();
  context.moveTo(x + radius, y);
  context.lineTo(r - radius, y);
  context.quadraticCurveTo(r, y, r, y + radius);
  context.lineTo(r, y + h - radius);
  context.quadraticCurveTo(r, b, r - radius, b);
  context.lineTo(x + radius, b);
  context.quadraticCurveTo(x, b, x, b - radius);
  context.lineTo(x, y + radius);
  context.quadraticCurveTo(x, y, x + radius, y);
  context.stroke();
};

export const verticalLine = () => (
  <span className="vertical-line p-relative h-100p ">&nbsp; </span>
);

export const intToString = (num: number, toFixed = 1) => {
  num = num.toString().replace(/[^0-9.]/g, "");
  if (num < 1000) {
    return num;
  }
  const si = [
    { v: 1e3, s: "k" },
    { v: 1e5, s: "L" },
    { v: 1e6, s: "m" },
    { v: 1e9, s: "b" },
    { v: 1e12, s: "t" },
    { v: 1e15, s: "p" },
    { v: 1e18, s: "e" },
  ];
  let index;
  for (index = si.length - 1; index > 0; index--) {
    if (num >= si[index].v) {
      break;
    }
  }
  return (
    (num / si[index].v)
      .toFixed(toFixed)
      .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[index].s
  );
};

export const getTextWidth = (inputText = "", font = "") => {
  const canvas = document.createElement("canvas");
  const context: CanvasRenderingContext2D = canvas.getContext(
    "2d"
  ) as CanvasRenderingContext2D;
  context.font = font;
  const width = context.measureText(inputText).width;
  return Math.ceil(width);
};

export const getFields = (input: any[], field: string | number) => {
  return input.map(function (o: { [x: string]: any }) {
    return o[field];
  });
};

export function removeObjInArr(arr: any[], attr: string, value: string) {
  let i = arr.length;
  while (i--) {
    if (
      arr[i] &&
      arr[i].hasOwnProperty(attr) &&
      arguments.length > 2 &&
      arr[i][attr] === value
    ) {
      arr.splice(i, 1);
    }
  }
  return arr;
}

export const getColorSC = (val: string) => {
  switch (val) {
    case seatStatus.NOT_AVAILABLE:
      return "#E6E6E6";
    case seatStatus.AVAILABLE_FOR_ALL:
      return "#B3B3B3";
    case seatStatus.AVAILABLE_ONLY_FOR_MALE:
    case seatStatus.BOOKED_BY_MALE:
      return "#0D99FF";
    case seatStatus.AVAILABLE_ONLY_FOR_FEMALE:
    case seatStatus.BOOKED_BY_FEMALE:
      return "#EF85CF";
    default:
      return "#B3B3B3";
  }
};

export const getCrossColor = (val: string) => {
  switch (val) {
    case seatStatus.NOT_AVAILABLE:
      return "#C8C8C8";
    case seatStatus.BOOKED_BY_MALE:
      return "#0087EA";
    case seatStatus.BOOKED_BY_FEMALE:
      return "#E773C4";
    default:
      return "#C8C8C8";
  }
};

export const getParsedPickData = (data: PickUpData[]) => {
  return ((data &&
    data.length > 0 &&
    data.map((el: PickUpData) => ({
      ...el,
      code: el.pickupCode,
      time: el.pickupTime,
      name: el.pickupName,
    }))) ||
    []) as unknown as PickDropProps[];
};

export const getParsedDropData = (data: DropOffData[]) => {
  return ((data &&
    data.length > 0 &&
    data.map((el: DropOffData) => ({
      code: el.dropOffCode,
      time: el.dropOffTime,
      name: el.dropOffName,
      ...el,
    }))) ||
    []) as unknown as PickDropProps[];
};

export const maxDate = 90;
export const availSeatFlag = 5;
export const fareCategory = {
  TF: ["TF"],
  BF: ["BF"],
  SKIP_FOR_LOOP: ["TF", "BF"],
  DIS: ["DIS", "SUPERCOIN_DIS"],
  SHOW_ALWAYS: ["CT_CONV", "CONV"],
  SKIP_FROM_BREAKUP: ["SUP_TAX", "SUP_TF"],
  SKIP_FROM_ITINERARY: ["CT_TF"],
};
export const skipChartHeightToScorll = 400; // 56 + 89 + 41 + 64 + 62 + 48 + 40
//--> header ht + chartTabs ht + seatsInfo ht in btm + proceed btn sect ht + spacing of chart content + spacing inside deck + header ht inside deck;
export const supportMobNo = 9595333333;

// seat chart colors
export const SelectedSeatColor = "#11A670";
export const NormalSeatColor = "#666666";

export const triggerPageLoadEvent = (
  data: ChartData["solutionId"],
  utmData: Record<string, string>
) => {
  const pageName = "Bus_Seatselection_Page";
  const { cc, chart } = data;
  const dx = Math.ceil(dayjs(cc?.journeyDate).diff(dayjs(), "day", true));
  const actionData = {
    sourceCity: cc?.fromCityName,
    destinationCity: cc?.toCityName,
    travelDate: dayjs(cc?.journeyDate).format("DD/MM/YY").toString(),
    isRTCBus: cc?.isGovt || false,
    srpRanking: 0,
    busRating: chart?.review?.rating || "NA",
    numberOfRatings: chart?.review?.ratingCount || "NA",
    numberOfSeatsLeft:
      chart?.availableSeats?.lower + chart?.availableSeats?.upper,
    pricePerSeat: cc?.pricePerSeat || 0,
    departureTime: dayjs(cc.deptTime).format("hh:mm A").toString(),
    arrivalTime: dayjs(cc.arrTime).format("hh:mm A").toString(),
    travelDuration: cc?.travelDuration || "",
    amenitiesShown: chart?.amenities?.length ? true : false,
    operatorName: cc?.operatorName || "",
    busType: cc?.displayBusType || "",
    busID: cc?.busId || "",
    is_cc_max_eligible:
      data?.fareInfo?.CFNR?.isEligible &&
      data?.chart?.cancellationPolicy.policy.length > 0
        ? "yes"
        : "no",
    searchId: cc?.searchId,
    dx,
    ...utmData,
  };

  sendBusPageLoad(
    "BUS_Page_Load",
    { pageName, ...actionData },
    "b_seatselection_pageload"
  );
  // sendToGTM({ pageName, ...actionData }, "BUS_Page_Load");
};
